module.exports = "<div class=\"webframe\">\n    <iframe *ngIf=\"webframeurl\" [src]=\"webframeurl\" ></iframe>\n</div>\n"